import React from "react";
import { Link } from 'react-router-dom';
import Footer from "../Footer/Footer.js";
import Choose from "../Services/Choose.js";
import { Helmet } from "react-helmet-async";
import ReactSlider from "./slider";
import hero from "../../assets/hero-purple.jpg";
import hero_mobile from "../../assets/hero-purple-mobile.jpg";
import healthier from "../../assets/healthier.jpg";
import bigheart from "../../assets/bigheart.png";
import regime_heart from "../../assets/regime-heart.png";
import arbonne from "../../assets/arbonne.jpg";
import arbonne_mobile from "../../assets/arbonne-mobile.jpg";
import arbonne_logo from "../../assets/arbonne-logo.png";
import instructors from "../../assets/instructors.jpg";

const Home = (props) => {
  
  return (
    <div className="container-home">
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="description" content="It's A Good Life Fitness" />
        <title>It's A Good Life Fitness | Home</title>
        <link rel="canonical" href="https://itsagoodlifefitness.com" />
      </Helmet>
      <section className="hero">
        <div className="hero-image">
          <img
            src={hero}
            id="desktop"
            width="1440"
            height="692"
            alt="Woman and man pushups"
          />
          <img
            src={hero_mobile}
            id="mobile"
            width="550"
            height="692"
            alt="Woman and man pushups"
          />
        </div>
        <article className="hero-header">
          <h1>Fueling The Body + Mind</h1>
          <Link to="#choose"><button className="button">Choose Your Regime</button></Link>
        </article>
      </section>
      <section className="ticker-container">
        <div className="ticker-wrap">
            <div className="ticker">
                <div className="ticker-item">Create a vision of a healthier you, play it over in your mind until it’s real.</div>
                <div className="ticker-item">What we believe we achieve.</div>
                <div className="ticker-item">Believe in yourself today!</div>
            </div>
        </div>
      </section>
      <section className="healthier-you">
        <div className="healthier-image">
          <img src={healthier} width="692" height="676" alt="Woman running" />
        </div>
        <article className="healthier-text">
          <div className="text-bg-image">
            <img src={bigheart} width="594" height="531" alt="Big heart" />
          </div>
          <div className="text">
            <h2>Body + Mind + Nutrition =</h2>
            <h3>A Healthier You</h3>
            <p>
              At It’s A Good Life Fitness (IGLF), we don’t buy into the
              unsustainable fad diets and unrealistic fitness goals you’ll find
              boasted on the internet. Instead, we train your mind just as hard
              as we challenge your body, cultivating a healthy mindset and
              well-rounded knowledge centered around fitness, nutrition, and
              mental wellness. The combination of these three pillars are IGLF’s
              unbeatable equation to Hacking Your Fitness Regime.
            </p>
          </div>
        </article>
      </section>
      <section className="regime">
        <article className="regime-header">
          <img src={regime_heart} width="119" height="55" alt="Purple circle, green heart" />
          <h3>Hack Your Fitness Regime</h3>
          <img src={regime_heart} width="119" height="55" alt="Purple circle, green heart" />
        </article>
        <div className="slider-container">
          <ReactSlider />
        </div>
      </section>

      <Choose {...props} />

      <section className="arbonne">
        <div className="bg-image">
          <img src={arbonne} id="desktop" width="1440" height="396" alt="Arbonne background" />
          <img src={arbonne_mobile} id="mobile" width="375" height="557" alt="Arbonne mobile background" />
        </div>
        <article className="description">
          <div className="image">
            <img src={arbonne_logo} width="337" height="231" alt="Arbonne logo" />
          </div>
          <div className="text">
            <h2>Proud Partners of Arbonne</h2>
            <p>
              Like It’s A Good Life Fitness, Arbonne is centered around
              promoting inner and outer health through unparalleled quality,
              safety, and results. Thanks to their holistic, plant-based
              ingredients, integrating Arbonne supplements into your daily
              routine is a sure way to improve your nutrition and boost your
              overall well-being.
            </p>
            <a href="https://www.arbonne.com/pws/denisenowak/tabs/home.aspx" target="_blank" rel="noopener noreferrer"><button className="button">Arbonne Supplements</button></a>
          </div>
        </article>
      </section>
      <section className="meet">
        <article className="text">
          <h3>Meet Your Instructors</h3>
          <p>
            Trained and certified, our instructors are ready to help you achieve
            your fitness goals!
          </p>
          <Link to="/about/"><button className="button">About Us</button></Link>
        </article>
        <div className="images">
          <img src={instructors} width="717" height="553" alt="Instructors" />
        </div>
      </section>
      <Footer {...props} />
    </div>
  );
};

export default Home;
